"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var CartItemTotalPrice = /** @class */ (function (_super) {
    __extends(CartItemTotalPrice, _super);
    function CartItemTotalPrice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartItemTotalPrice.prototype.render = function () {
        var _a = this.props, price = _a.price, lineitem = _a.lineitem, format = _a.format, inline = _a.inline;
        var onSale = lineitem.compare_at_line_price > lineitem.line_price;
        return onSale ? (React.createElement("div", { className: (inline ? "flex items-center justify-end " : "") + " " + (this.props.className ? this.props.className : null) },
            React.createElement("p", { className: "block font-semibold " + (inline ? "mr-0-6" : "mb-0-4") + " " + (this.props.sale ? "text-red" : "text-midnight") }, next_components_1.ShopifyNext.Utils.formatMoney(lineitem.line_price, format)),
            this.props.sale && (React.createElement("p", { className: "text-grey-dark mb-0-2" },
                React.createElement("span", { className: "block text-xs" }, next_components_1.ShopifyNext.Utils.formatMoney(lineitem.compare_at_line_price, format)))))) : (React.createElement("p", { className: "font-semibold " + (this.props.className ? this.props.className : null) }, next_components_1.ShopifyNext.Utils.formatMoney(lineitem.line_price, format)));
    };
    return CartItemTotalPrice;
}(React.PureComponent));
exports.CartItemTotalPrice = CartItemTotalPrice;
